var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "b-form",
        { attrs: { "data-vv-scope": "bidder-form" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: { label: "Rut", "label-for": "iut" }
            },
            [
              _c("b-form-input-rut", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|validateRut",
                    expression: "'required|validateRut'"
                  }
                ],
                attrs: {
                  id: "iut",
                  name: "iut",
                  "data-cy": "bidder-iut",
                  placeholder: "Rut",
                  state: _vm.errors.has("bidder-form.iut") ? false : null,
                  "data-vv-as": "Rut",
                  disabled: !!_vm.bidder.id,
                  truncateValue: ""
                },
                model: {
                  value: _vm.bidder.identification,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "identification", $$v)
                  },
                  expression: "bidder.identification"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(" " + _vm._s(_vm.errors.first("bidder-form.iut")) + " ")
              ])
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: {
                "data-vv-as": "Nombre / razón social",
                label: "Nombre / razón social",
                "label-for": "name"
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:100",
                    expression: "'required|max:100'"
                  }
                ],
                attrs: {
                  id: "name",
                  name: "name",
                  "data-cy": "bidder-name",
                  placeholder: "Nombre",
                  "data-vv-as": "Nombre",
                  state: _vm.errors.has("bidder-form.name") ? false : null
                },
                model: {
                  value: _vm.bidder.name,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "name", $$v)
                  },
                  expression: "bidder.name"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(" " + _vm._s(_vm.errors.first("bidder-form.name")) + " ")
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-1 text-right",
                  attrs: { variant: "primary", "data-cy": "next-button" },
                  on: {
                    click: function($event) {
                      return _vm.createBidder()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }